(function () {
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  let rebuyInflight = null;

  function getRebuyCartWidget() {
    return document.querySelector('[data-rebuy-id="248890"]');
  }

  function reloadRebuyCartWidget() {
    let rebuyCartWidget = getRebuyCartWidget();
    const widgetInstance = window.Rebuy?.widgets;
    const cartItemsCount = window.Rebuy?.Cart.cart.item_count || 0;

    if (!rebuyCartWidget) return;
    // Only run the fade/init/refresh if the Rebuy widget with id 248890 is NOT
    // already present in the global widgets array. This avoids re-initializing
    // a widget instance that already exists.
    try {
      const widgets = Array.isArray(widgetInstance) ? widgetInstance : [];
      const hasWidget = widgets.some(
        (widget) =>
          String(widget.id) === '248890' ||
          (widget.element && widget.element.dataset && widget.element.dataset.rebuyId === '248890')
      );

      if (!hasWidget) {
        if (window.Rebuy) {
          console.log('Rebuy widget instance not found, refreshing for id 248890');
          window.Rebuy.reinit();
        }
      } else if (hasWidget && cartItemsCount === 0) {
        if (window.Rebuy) {
          window.Rebuy.reinit();
        }
      } else {
        console.log('Rebuy widget instance already present, skipping init/reload for id 248890');
      }
    } catch (e) {
      console.warn('Error checking Rebuy widgets array, proceeding with refresh as fallback', e);
      if (window.Rebuy) {
        window.Rebuy.reinit();
      }
    }
  }

  async function refreshCartDrawerAfterRebuy() {
    if (rebuyInflight) return rebuyInflight;
    const cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return;
    rebuyInflight = (async () => {
      const res = await fetch(`/?sections=${encodeURIComponent(SECTIONS.join(','))}`, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
      });
      if (!res.ok) throw new Error(`Sections fetch failed: ${res.status}`);
      const sections = await res.json();
      cartDrawerEl.renderContents({ id: null, sections });
      try {
        const doc = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
        const countText = doc.querySelector('.cart-count-parentheses')?.textContent || '(0)';
        const count = parseInt(countText.replace(/[()]/g, ''), 10) || 0;
        if (count > 0) {
          cartDrawerEl.classList.remove('is-empty');
        } else {
          cartDrawerEl.classList.add('is-empty');
        }
      } catch (e) {
        cartDrawerEl.classList.remove('is-empty');
      }
      setTimeout(() => {
        cartDrawerEl
          .querySelector('#CartDrawer-Overlay')
          ?.addEventListener('click', cartDrawerEl.close.bind(cartDrawerEl));
        if (typeof cartDrawerEl.setHeaderCartIconAccessibility === 'function') {
          cartDrawerEl.setHeaderCartIconAccessibility();
        }
        if (!cartDrawerEl.classList.contains('active')) {
          cartDrawerEl.open();
        }
      }, 0);
    })().finally(() => {
      rebuyInflight = null;
      const cartItems = document.querySelectorAll('cart-drawer-items .cart-item');
      reloadRebuyCartWidget(cartItems);
    });
    return rebuyInflight;
  }

  function handleRebuyEvent() {
    console.log('Rebuy event triggered [layout/theme.liquid], refreshing cart drawer');
    refreshCartDrawerAfterRebuy().catch((err) => console.error('Rebuy → cart drawer refresh failed:', err));
  }

  const rebuyEvents = ['rebuy.add', 'rebuy.remove', 'rebuy.update'];
  rebuyEvents.forEach((evt) => document.addEventListener(evt, handleRebuyEvent));

  document.addEventListener('pdp:productAdded', () => {
    console.log('Product added event detected, reloading Rebuy cart widget');
    const cartItems = document.querySelectorAll('cart-drawer-items .cart-item');
    reloadRebuyCartWidget(cartItems);
  });
})();
